import React from "react"
import { DioboxEvent, GuestStatus } from "sharedTypes"
import { Box } from "@chakra-ui/react"
import GuestCard from "pages/EventShow/Submissions/FormSubmissions/FormSubmissionsDetailView/LineItemView/GuestCard/GuestCard"
import useResolvedTranslations from "pages/EventShow/Settings/LanguageTemplates/useResolvedTranslations"

type Props = {
  event: DioboxEvent
  /** The languageTemplateId of the form currently being previewed, if any — see
   * PreviewFrameWithBranding's `languageTemplateId` prop for why this matters. */
  languageTemplateId?: string | null
}

const dummyLineItem = {
  guest: {
    id: "a933ee7c-e9c3-4d8e-92a6-734b1f300bb6",
    name: "John Doe",
    firstName: "John",
    lastName: "Doe",
    email: "john.doe@example.com",
    photoUrl: "https://example.com/photo.jpg",
    qrCodeUrl: "http://api.qrserver.com/v1/create-qr-code/?size=100x100&data=a933ee7c-e9c3-4d8e-92a6-734b1f300bb6",
    status: GuestStatus.Confirmed,
  },
}

const GuestConfirmationPage = ({ event, languageTemplateId }: Props) => {
  const {
    guest: {
      firstName, lastName, email, status, qrCodeUrl, id,
    },
  } = dummyLineItem
  const {
    unconfirmed,
    confirmed,
    declined,
    waitlisted,
    qrCodeForCheckIn,
  } = useResolvedTranslations(languageTemplateId)

  return (
    <Box pt={8}>
      <GuestCard
        name={`${firstName} ${lastName}`}
        email={email}
        status={status}
        statuses={[
          unconfirmed,
          confirmed,
          declined,
          waitlisted,
        ]}
        qrCodeUrl={qrCodeUrl}
        qrCodeText={qrCodeForCheckIn}
        event={event}
        guestId={id}
      />
    </Box>
  )
}

export default GuestConfirmationPage
